export const LOAD_SYSTEM_NOTIFICATIONS = "LOAD_SYSTEM_NOTIFICATIONS";
export const LOAD_SYSTEM_NOTIFICATIONS_SUCCESS = "LOAD_SYSTEM_NOTIFICATIONS_SUCCESS";
export const LOAD_SYSTEM_NOTIFICATIONS_FAILURE = "LOAD_SYSTEM_NOTIFICATIONS_FAILURE";
